import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import SeoHelmets from '../SeoOptimazation/SeoHelmets';
import Content from '../AllPageContent/AllPageContent';
import Buttontabs from '../Buttontabs/Buttontabs';
import CurrentAffair from '../CurrentAffair/CurrentAffair';
import "../CurrentPage/Current.css";
import { fetchAllUGCAbouts } from '../DynamicCourse/api';
import Loader from '../Loader/Loader';
import ButtonPage from '../ButtonPage/ButtonPage';

function UGC_NET_Home() {
    const [contentToShow, setContentToShow] = useState('CUET');
    const [ugcAbouts, setUgcAbouts] = useState([]);
    const [selectedAbout, setSelectedAbout] = useState(null);
    const [loading, setLoading] = useState(false);
    const componentName = "ugc_net";
    const navigate = useNavigate();

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            try {
                const data = await fetchAllUGCAbouts();
                setUgcAbouts(data || []);
                // Set first about as selected by default
                if (data && data.length > 0) {
                    setSelectedAbout(data[0]);
                }
            } catch (error) {
                console.error('Error fetching data:', error);
            } finally {
                setLoading(false);
            }
        };
        fetchData();
    }, []);

    return (
        <>
            <SeoHelmets 
                title={selectedAbout?.Title ? `${selectedAbout.Title} | UGC NET Preparation - Insight IAS` : "UGC NET Exam Preparation & Test Series"} 
                description={selectedAbout?.Title ? `Learn everything about ${selectedAbout.Title} for the UGC NET exam. Expert guidance and resources from Insight IAS Delhi.` : "Ace the National Eligibility Test (UGC-NET) with our expert-led preparation programs and comprehensive test series."} 
                keywords="UGC NET preparation, JRF coaching, NET test series, UGC NET study material, Insight IAS"
            />
            <div className='Cuet-background'>
                <div className='current-main-box'>
                    <h1>The National Eligibility Test (UGC-NET) »»</h1>
                    <Buttontabs componentName={componentName} setContentToShow={setContentToShow} />
                </div>
            </div>
            <div className='container-fluid cuet-width py-4'>
                <div className='row'>
                    <div className='col-lg-8 col-md-12 col-sm-12'>
                        {loading ? (
                            <div className='card d-flex align-items-center justify-content-center' style={{ minHeight: '400px', position: 'relative' }}>
                                <Loader />
                            </div>
                        ) : (
                            <>
                                {/* All About Sections */}
                                {ugcAbouts.length > 0 ? (
                                    <div className="ugc-abouts-container">
                                        {ugcAbouts.map((about, index) => (
                                            <div key={about.Sn} className="about-section mb-5">
                                                <h2 className="fw-bold mb-3" style={{ color: '#dc3545', borderBottom: '2px solid #dc3545', display: 'inline-block', paddingBottom: '5px' }}>
                                                    {about.Title}
                                                </h2>
                                                <Content paragraphs={about?.Description || []} />
                                                <hr className="my-4" style={{ opacity: 0.1 }} />
                                            </div>
                                        ))}
                                    </div>
                                ) : (
                                    <div className='card d-flex align-items-center justify-content-center' style={{ minHeight: '400px', position: 'relative' }}>
                                        <p>No Information Available</p>
                                    </div>
                                )}
                                <ButtonPage Pagename="EnquiryOnly" noteurl="" />
                            </>
                        )}
                    </div>
                    <div className='col-lg-4 card px-0 col-md-12 col-sm-12'>
                        <CurrentAffair componentName={componentName} />
                    </div>
                </div>
            </div>
        </>
    );
}

export default UGC_NET_Home;